import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/essex/Header";
import HeroSection from "@/components/essex/HeroSection";
import StatsSection from "@/components/essex/StatsSection";
import ServicesSection from "@/components/essex/ServicesSection";
import WhyChooseUs from "@/components/essex/WhyChooseUs";
import FeaturedFilms from "@/components/essex/FeaturedFilms";
import MeetAlex from "@/components/essex/MeetAlex";
import PackagesSection from "@/components/essex/PackagesSection";
import VenueShowcase from "@/components/essex/VenueShowcase";
import BlogContent from "@/components/essex/BlogContent";
import ReviewsSection from "@/components/essex/ReviewsSection";
import FAQSection from "@/components/essex/FAQSection";
import Footer from "@/components/essex/Footer";
import { SecureDateCTA } from "@/components/essex/SecureDateCTA";
import { InstagramSection } from "@/components/essex/InstagramSection";

export default function EssexWeddingVideo() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const timer = setTimeout(() => {
        const el = document.querySelector(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div data-testid="essex-wedding-page" className="bg-[#0A0908] min-h-screen">
      <Helmet>
        <title>Wedding Videographer & Photographer Essex | Cinematic Wedding Films | Wedding Video Essex</title>
        <meta name="description" content="Wedding Video Essex is an award-winning wedding videographer and photographer based in Wickford, Essex. Two videographers on every booking. Full day coverage. Cinematic wedding films. Over 900 weddings filmed across Essex, London, Kent, and the South East. Packages from £2,295." />
        <link rel="canonical" href="https://essex.weddingvideo.co.uk" />
      </Helmet>
      <Header />
      <main role="main" aria-label="Essex Wedding Photography and Videography">
        <HeroSection />
        <StatsSection />
        <ServicesSection />
        <MeetAlex />
        <WhyChooseUs />

        <FeaturedFilms />

        <div className="max-w-6xl mx-auto px-6 md:px-12 py-4">
          <SecureDateCTA
            variant="inline"
            heading="Want something like this for your wedding?"
            subtext="Drop us your details and we'll have a chat."
          />
        </div>

        <VenueShowcase />
        <PackagesSection />

        <SecureDateCTA
          heading="Found your dream venue?"
          subtext="We've worked at all of these venues and know them inside out. Let us know your date and we'll take it from there."
        />

        <BlogContent />
        <ReviewsSection />

        <InstagramSection />

        <div className="max-w-6xl mx-auto px-6 md:px-12 py-4">
          <SecureDateCTA
            variant="inline"
            heading="Like what you see so far?"
            subtext="Pop your details in and we'll take it from there."
          />
        </div>

        <FAQSection />

        <SecureDateCTA
          heading="Ready to secure your date?"
          subtext="We only take a limited number of weddings each month. Pop your details in and we'll get back to you within 24 hours."
        />
      </main>
      <Footer />
    </div>
  );
}
